import {
  $createParagraphNode,
  EditorConfig,
  ElementNode,
  LexicalEditor,
  LexicalNode,
  RangeSelection,
  SerializedElementNode,
  Spread,
} from 'lexical';

export type SerializedAlertNode = Spread<
  {
    type: 'alert';
  },
  SerializedElementNode
>;

export class AlertNode extends ElementNode {
  static getType(): string {
    return 'alert';
  }

  static clone(node: AlertNode): AlertNode {
    return new AlertNode(node.__key);
  }

  createDOM(_config: EditorConfig, _editor: LexicalEditor): HTMLElement {
    const element = document.createElement('div');

    element.className = _config.theme.alert;

    return element;
  }

  updateDOM(
    _prevNode: unknown,
    _dom: HTMLElement,
    _config: EditorConfig
  ): boolean {
    return false;
  }

  static importJSON(serializedNode: SerializedAlertNode): LexicalNode {
    const node = $createAlertNode();

    node.setFormat(serializedNode.format);
    node.setIndent(serializedNode.indent);
    node.setDirection(serializedNode.direction);

    return node;
  }

  exportJSON(): SerializedAlertNode {
    return {
      ...super.exportJSON(),
      type: 'alert',
    };
  }

  insertNewAfter(
    selection: RangeSelection,
    restoreSelection?: boolean | undefined
  ): LexicalNode | null {
    const anchorOffet = selection ? selection.anchor.offset : 0;
    const newElement =
      anchorOffet === this.getTextContentSize() || !selection
        ? $createParagraphNode()
        : $createAlertNode();
    const direction = this.getDirection();
    newElement.setDirection(direction);
    this.insertAfter(newElement, restoreSelection);

    if (anchorOffet === 0 && !this.isEmpty() && selection) {
      const paragraph = $createParagraphNode();
      paragraph.select();
      this.replace(paragraph, true);
    }
    return newElement;
  }

  collapseAtStart() {
    const paragraph = $createParagraphNode();
    const children = this.getChildren();
    children.forEach((child) => paragraph.append(child));
    this.replace(paragraph);
    return true;
  }
}

export function $createAlertNode(): AlertNode {
  return new AlertNode();
}

export function $isAlertNode(node: LexicalNode): node is AlertNode {
  return node instanceof AlertNode;
}
